import React from 'react';
import styled from 'styled-components';
import { Spinner } from '@panel/commons/lib/Spinner/Spinner';
import { getColor } from '@panel/commons/core/themev3';

const LoaderWrapper = styled.div`
  position: ${props => (props.isDesktop ? 'relative' : 'absolute')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${props => (props.isDesktop ? '90vh' : '100%')};
`;

const LoadingScreenContent = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 56px;
`;

function LoadingScreen({ isDesktop }) {
  return (
    <LoaderWrapper isDesktop={isDesktop}>
      <LoadingScreenContent>
        <Spinner size='32' lineWidth='4' color={getColor('primary')} />
      </LoadingScreenContent>
    </LoaderWrapper>
  );
}

export default LoadingScreen;
